import { render, staticRenderFns } from "./ComplainChecklist.vue?vue&type=template&id=f295beda&"
import script from "./ComplainChecklist.vue?vue&type=script&lang=js&"
export * from "./ComplainChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports